import { useGetEventQuery } from "event/api/event.api";
import { useParams } from "react-router-dom";
import { Header2 } from "./Header2";
import { Header } from "./Header";

export function EventHeader() {
  const { eventId } = useParams<{ eventId: string }>();
  const { data } = useGetEventQuery(eventId as string);

  return <>{data?.header?.enabled ? <Header2 /> : <Header />}</>;
}
